export enum CardStatus {
  NOT_VALIDATED,
  VALIDATING,
  VALIDATED,
}
